import { getLocal } from './storage';
import { isNotBlank, isArray } from './util';
import { PERMISSION, CURRENT_USER_INFO } from '../constants/common';

/**
 * @desc 根据权限码判断是否有权限
 */
export function author(code) {
    let permissions = getLocal(PERMISSION);
    return isArray(permissions) && permissions.includes(code);
}

/**
 * @desc 是否为超级管理员
 */
export function isSuperAdmin() {
    return getLocal('userId') === 1;
}

// 是否是指定的用户类型
export function isSpecificUser(uType = '') {
    if (isNotBlank(uType)) {
        let uTypeArray = uType.split(',');    // 用户类型
        let current = getLocal(CURRENT_USER_INFO) || {};
        return uTypeArray.some( type => current.type === Number(type));
    }
    return true;
}

// 是否有权限码
export function isPermited(permission = '') {
    if (isNotBlank(permission)) {
        let permissionArray = permission.split(',');// 权限码数组
        return permissionArray.some( code => author(code));
    }
    return true;
}

// 能否访问
export function canAccess(params) {
    return 'uType' in params ? isSpecificUser(params.uType) : isPermited(params.permission);
}



// WEBPACK FOOTER //
// ./src/utils/permission.js